/**
 * @file
 * Adds a custom plugin to handle map markers.
 */
(function() {
  const Datamap = require('datamaps');
  const d3 = require('d3');
  if (typeof Datamap !== 'undefined') {
    // Handler custom markers.
    Datamap.customMarkers = function (layer, data, options) {
      var self = this,
        fillData = this.options.fills,
        svg = this.svg;

      // Check for map data.
      if (!data || (data && !data.slice)) {
        throw "Datamaps Error - markers must be an array";
      }

      // Build defs
      var symbols = layer
        .selectAll('.datamaps-markers-symbols')
        .data(options.symbols, def => def.id);
      symbols
        .enter()
        .append(symbol => symbol)
        .attr('class', 'datamaps-markers-symbols');
      symbols.exit()
        .remove();
      

      // Build markers.
      var markers = layer
        .selectAll('image.datamaps-markers')
        .data(data, JSON.stringify);

      const xOffset = options.xOffset || ((latLng, markerData, options) => latLng[0] - (options.icon.width / 2));
      const yOffset = options.yOffset || ((latLng, markerData, options) => latLng[1] - (options.icon.height / 2)); 

      markers
        .enter()
        .append('use')
        .attr('width', options.icon.width)
        .attr('height', options.icon.height)
        .attr('class', function (markerData) {
          return 'datamaps-marker' + (markerData.className ? ' ' + markerData.className : '');
        })
        .attr('href', function (markerData) {
          return markerData.iconHref;
        })
        .attr('xlink:href', function (markerData) {
          return markerData.iconHref;
          return markerData?.iconUrl || options.icon.url;
        })
        .attr('x', function (markerData) {
          var latLng;
          if (markerHasCoordinates(markerData)) {
            latLng = self.latLngToXY(markerData.latitude, markerData.longitude);
          }
          else if (markerData.centered) {
            latLng = self.path.centroid(svg.select('path.' + markerData.centered).data()[0]);
          }
          if (latLng) return xOffset(latLng, markerData, options);
        })
        .attr('y', function (markerData) {
          var latLng;
          if (markerHasCoordinates(markerData)) {
            latLng = self.latLngToXY(markerData.latitude, markerData.longitude);
          }
          else if (markerData.centered) {
            latLng = self.path.centroid(svg.select('path.' + markerData.centered).data()[0]);
          }
          if (latLng) return yOffset(latLng, markerData, options);
        })
        .on('mouseover', function (markerData) {
          var $this = d3.select(this);
          if (options.popupOnHover) {
            self.updatePopup($this, markerData, options, svg);
          }
        })
        .on('mouseout', function (markerData) {
          var $this = d3.select(this);
          if (options.highlightOnHover) {
            // Reapply previous attributes.
            var previousAttributes = JSON.parse($this.attr('data-previousAttributes'));
            for (var attr in previousAttributes) {
              $this.style(attr, previousAttributes[attr]);
            }
          }
          d3.selectAll('.datamaps-hoverover').style('display', 'none');
        })

      markers.exit()
        .transition()
        .delay(options.exitDelay)
        .attr("height", 0)
        .remove();

      // Checks if a marker has latitude and longitude provided.
      function markerHasCoordinates(markerData) {
        return typeof markerData !== 'undefined' && typeof markerData.latitude !== 'undefined' && typeof markerData.longitude !== 'undefined';
      }
    }
  }
})();
